import { writable } from 'svelte/store';

export const userid = writable(null);
export const currentUser = writable(null);

export const isEmpty = (object) => {
  return Object.keys(object).length == 0;
};
